module.exports = __webpack_public_path__ + "static/img/entrada.e561799.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/entrada.jpeg
// module id = 8LhJ
// module chunks = 1